//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { chatRecharge, getWalletRecharge,getWalletStat } from '../../api/api';
import { getVuxUrlQuery, createRequest } from "../../utils/utils";
// var Button = videojs.getComponent('Button');
//处理tab焦点问题，不需要聚焦
// Button.prototype.handleKeyDown = (e)=>{
//     e.target.blur();
// };

var setTimeHandler=undefined
var payMoneyStatus=0
export default {
    name: "PaymentModel",
    props: {
        purchaseModelOpen:Boolean,
        stateIs:Number
        // src:String,
        // poster:String,
        // onPlayerReady:Function,
        // options: {
        //     type: Object,
        //     default() {
        //         return {};
        //     }
        // }
    },
    data() {
        return {
            purchaseList:[],
            purchaseModelIsopen:false,
            selectPurchaseIndex:0,
            balanceCount:0,
            starNoteEnough:[]
        }
    },
    mounted() {
        this.getPurchaseConfing();
        this.getWalletStat()
    },
    beforeDestroy() {
       
    },
    methods:{
        //获取余额
        getWalletStat()
        {
          getWalletStat().then(res=>{
            this.balanceCount = res.data.balance;
            this.purchaseList.forEach(item=>{
              if(item.star_coin <= res.data.balance)
              {

                console.log('%c⧭', 'color: #00ff88', item)
                this.starNoteEnough.push(item)
              }
            })
            console.log('%c⧭', 'color: #f279ca', this.starNoteEnough)
          })
        },
        //选择支付选项
        onSelectPurchase(index,item)
        {
            this.selectPurchaseIndex = index;
        },
        //获取充值配置
        getPurchaseConfing()
        {
            createRequest(
                "get",
                "applet/chat/recharge/config",
                {},
                (res) => {
                console.log("%c⧭", "color: #d90000", res.data);
                if (res.code == 200) {
                    this.purchaseList = res.data.recharge_config;
                    console.log('%c⧭', 'color: #7f7700', res)
                } else {
                    this.$vux.toast.show({
                    type: "text",
                    text: res.msg,
                    });
                }
                }
            );
        },
        //取消支付model
        onCancelPurchaseModel()
        {
            this.selectPurchaseIndex = 0;
            this.purchaseModelIsopen = false;
            this.$emit("informCancelPurchase",false)
             this.starNoteEnough=[]
            this.getWalletStat();
            
        },
        //立即支付
        onImmediatelyPurchase()
        {
            if(this.payTime && Date.now()-this.payTime<1000){
              return
            }
            this.payTime = Date.now()
            let that = this
            //支付成功通知 false===> 关闭父级的model状态
            if(this.purchaseList[this.selectPurchaseIndex] ){
              chatRecharge(this.purchaseList[this.selectPurchaseIndex].star_coin).then(res=>{
                if(res.data.type==0){//支付成功
                  this.$emit('informImmediatelyPurchase',true)
                }
                else if(res.data.type==2){//跳转微信支付
                  let query =`?order_id=${encodeURIComponent(res.data.order_id)}`
                        + `&appId=${encodeURIComponent(res.data.wx_jspay_params.appId)}`
                        + `&timeStamp=${encodeURIComponent(res.data.wx_jspay_params.timeStamp)}`
                        + `&nonceStr=${encodeURIComponent(res.data.wx_jspay_params.nonceStr)}`
                        + `&package=${encodeURIComponent(res.data.wx_jspay_params.package)}`
                        + `&signType=${encodeURIComponent(res.data.wx_jspay_params.signType)}`
                        + `&paySign=${encodeURIComponent(res.data.wx_jspay_params.paySign)}`
                  

                  this.$wechat.miniProgram.navigateTo({
                    url:'/walletPage/pages/commonRecharge/commonRecharge'+query ,
                      success:function(){
                        console.log('跳转成功')
                        //定时监控订单支付状态
                        if(setTimeHandler){
                          clearInterval(setTimeHandler);
                        }
                        setTimeHandler = setInterval(()=>{
                          getWalletRecharge(res.data.order_id).then(res=>{
                              payMoneyStatus =  res.data.status

                              if(payMoneyStatus == 2){ //充值成功
                              clearInterval(setTimeHandler);

                              that.$emit('informImmediatelyPurchase',true)
                            }
                          })
                          
                        },1000)
                    }
                  })
                }
              })
              setTimeout(()=>{
                this.starNoteEnough=[]
                this.getWalletStat();
              },1000)
            }
            
        },
    },
    watch:{
       async purchaseModelOpen(value)
       {
        await this.getWalletStat();
        this.purchaseModelIsopen = value;
       },
    }
}



// WEBPACK FOOTER //
// ./src/myComponents/PaymentModel/PaymentModel.vue